import { useState, MyIcon, get, useLocation, forwardRef, useImperativeHandle, useEffect, Func, post } from '@/common'
import { Modal, Form, message, Space, InputNumber, TreeSelect, Tree } from 'antd';
import './TreeFilter.scss';
import {
    PlusOutlined,
    EllipsisOutlined,
    MoreOutlined,
    DeleteOutlined,
    EditOutlined
} from '@ant-design/icons';


function Main(props: any, ref: any) {
    // const location = useLocation()
    // const pathname = props.apiUrl || location.pathname
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selected_keys, setSelectedKeys] = useState<any>([]);
    const [checked_keys, setCheckedKeys] = useState<any>([]);
    const [managing, setManaging] = useState(false);

    const [form] = Form.useForm();
    const title = props.title || '分类'

    const ok = () => {
        if (loading) return
        setLoading(true)
        form.validateFields().then((data: any) => {
            if (props.submitBefore) props.submitBefore(data)
            let url = `${props.action}/add`
            if (managing) {
                url = `${props.action}/edit/${form.getFieldValue('id')}`
            }
            post(url, data).then((data) => {
                if (data.code) return
                setOpen(false)
                getData()
            })
                .finally(() => {
                    setLoading(false)
                })
        })
            .catch(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        if (props.preventGet) return
        getData()
    }, [])

    const getData = () => {
        setManaging(false)
        get(props.action, props.filter).then(data => {
            if (data.data) {
                let data_original = data.data
                data = [...data_original]

                if (props.isRadio && props.itemAll && data.length) {
                    data.unshift({
                        id: '',
                        name: '全部',
                    })
                }
                let expanded_keys: any = []
                Func.unlimited(data, (e) => {
                    e.key = e.value = e.id
                    e.title = e.name
                    if (e.children) {
                        expanded_keys.push(e.key)
                    }
                })
                setData(data)
                setExpandedKeys(expanded_keys)
                if (data.length && props.isRadio) {
                    setSelectedKeys([data[0].key])
                    if (props.onSelect) props.onSelect(data[0])
                }
                if (props.listSuccess) props.listSuccess(data_original)
            }
        })
    }

    useEffect(() => {
        Func.unlimited(data, (e) => {
            e.title = (managing && e.id) ? <div>{e.name}<EditOutlined style={{ marginLeft: '5px' }} onClick={() => {
                setOpen(true)
                form.setFieldsValue(e)
            }} /><DeleteOutlined style={{ marginLeft: '5px' }} onClick={() => {
                Modal.confirm({
                    title: `确认是否删除${e.name}？`,
                    onOk() {
                        post(`${props.action}/del`, [e.id]).then(data => {
                            if (data.code) return
                            getData();
                            if (props.delSuccces && typeof (props.delSuccces) == "function") props.delSuccces()
                        })
                    }
                })
            }} /></div> : e.name
            if (managing && !e.id) {
                e.disabled = true
                e.checkable = false
            }
        })
        setData([...data])
    }, [managing])

    const onSelect = (selectedKeys: any, e: any) => {
        if (managing) return
        // 单选不可取消选中
        if (props.isRadio && !e.selected) {
            return
        }
        setSelectedKeys(selectedKeys)
        if (props.onSelect) props.onSelect(e.selectedNodes[0])
    }

    const onExpand = (expanded_keys: any) => {
        setExpandedKeys(expanded_keys)
    }

    const onCheck = (checkedKeys: any) => {
        setCheckedKeys(checkedKeys)
    }

    // 暴露方法
    useImperativeHandle(ref, () => ({
        reload: () => {
            getData()
        },
    }));
    return (
        <div className='space' style={{ width: props.width || '228px' }}>
            <div className='top'>
                <div className='title'>{title}</div>
                {
                    props.allowEdit &&
                    <div className='ope'>
                        <PlusOutlined title='添加' onClick={() => {
                            setOpen(true)
                            form.resetFields()
                            form.setFieldsValue({
                                space_id: 0
                            })
                        }} />
                        <a title='管理' onClick={() => {
                            setManaging(!managing)
                        }}>
                            {
                                managing ? <MoreOutlined /> : <EllipsisOutlined />
                            }
                        </a>
                        {
                            managing &&
                            <DeleteOutlined title='删除' onClick={() => {
                                if (!checked_keys.length) {
                                    message.warn('没有选中' + title)
                                    return
                                }
                                Modal.confirm({
                                    title: `确认是否删除选中${title}？`,
                                    onOk() {
                                        post(`${props.action}/del`, checked_keys).then(data => {
                                            if (data.code) return
                                            getData();
                                            if (props.delSuccces && typeof (props.delSuccces) == "function") props.delSuccces()
                                        })
                                    }
                                })
                            }} />
                        }
                    </div>
                }
            </div>
            <div className='tree'>
                <Tree
                    checkable={managing}
                    blockNode={true}
                    expandedKeys={expandedKeys}
                    onSelect={onSelect}
                    onExpand={onExpand}
                    onCheck={onCheck}
                    treeData={data}
                    selectedKeys={selected_keys}
                />
                {
                    !data.length &&
                    <div className='empty'>
                        <MyIcon type='icon-wushuju' />
                        <div>暂无{title}</div>
                    </div>
                }
            </div>
            <Modal open={open} title={`添加${title}`} onCancel={() => setOpen(false)} maskClosable={false} onOk={ok} >
                <Form form={form} className="form" labelCol={{ span: props.labelCol || 3 }}>
                    {props.children}
                </Form>
            </Modal>
        </div>
    )
}
export default forwardRef(Main)